import Cookies from 'js-cookie';
import { isBrowser } from '../Utils/Helpers';
export const CART_ASO_APARTMENT = 'wordpress_as_cart_aso_apartment';
export const CART_ASO_COST_UNIT = 'wordpress_as_cart_aso_cost_unit';
export const CART_RENT_APARTMENT = 'wordpress_as_cart_rent_apartment';
export const CART_RENT_COST_UNIT = 'wordpress_as_cart_rent_cost_unit';
export const CART_CHANGE_EVENT = 'as-cart-changed';
export const APARTMENT_APPLICATION_URL = isBrowser()
  ? // eslint-disable-next-line no-undef
    localizedParams.applicationFormUrl
  : '';
export const RENTAL_APPLICATION_URL = isBrowser()
  ? // eslint-disable-next-line no-undef
    localizedParams.applicationRentalFormUrl
  : '';

export const REMOVED_APARTMENTS = isBrowser()
  ? // eslint-disable-next-line no-undef
    localizedParams.removedApartments
  : '';

const event = new Event(CART_CHANGE_EVENT);

/**
 * All cart names
 * @type {(string)[]}
 */
const allCarts = [
  CART_ASO_APARTMENT,
  CART_ASO_COST_UNIT,
  CART_RENT_APARTMENT,
  CART_RENT_COST_UNIT,
];

/**
 *
 * @param name
 * @param value
 */
const setCart = (name, value) => {
  Cookies.set(name, JSON.stringify(value), { expires: 3 });
  document.dispatchEvent(event);
};

/**
 *
 * @param cart
 * @returns []
 */
const getCart = (cart) => {
  const currentCart = Cookies.get(cart);

  return currentCart === undefined ? [] : JSON.parse(currentCart);
};

/**
 *
 * @param id
 * @param cart
 */
export const addToCart = (id, cart) => {
  const currentCart = getCart(cart);
  const intId = parseInt(id);
  // Don't add the same id twice
  if (currentCart.indexOf(id) === -1) {
    currentCart.push(intId);
    setCart(cart, currentCart);
  }
};

/**
 *
 * @param ids array
 * @param cart string
 */
export const bulkAddToCart = (ids, cart) => {
  const currentCart = getCart(cart);

  ids.forEach((id) => {
    currentCart.push(parseInt(id));
  });

  setCart(cart, [...new Set(currentCart)]);
};

/**
 * Removes all items from cart by name.
 *
 * @param cart string
 */
export const removeEverythingFromCart = (cart) => {
  setCart(cart, []);
};

/**
 *
 * @param id
 * @param cart
 */
export const removeFromCart = (id, cart) => {
  const currentCart = getCart(cart);
  const intId = parseInt(id);
  const updatedCart = currentCart.filter((cartItem) => {
    return cartItem !== intId;
  });

  setCart(cart, updatedCart);
};

/**
 *
 * @param ids array
 * @param cart string
 */
export const bulkRemoveFromCart = (ids, cart) => {
  const currentCart = getCart(cart);
  const intIds = ids.map((id) => {
    return parseInt(id);
  });
  const updatedCart = currentCart.filter((cartItem) => {
    return !intIds.includes(cartItem);
  });

  setCart(cart, updatedCart);
};

/**
 *
 * @param id
 * @param cart
 * @returns boolean
 */
export const isInCart = (id, cart) => {
  const currentCart = getCart(cart);
  const intId = parseInt(id);
  return currentCart.includes(intId);
};

/**
 *
 * @returns {boolean}
 */
export const anythingInAnyCart = () => {
  let response = false;

  allCarts.forEach((cartName) => {
    const currentCart = getCart(cartName);
    if (currentCart.length && response === false) {
      response = true;
    }
  });

  return response;
};

export const checkAllowedPropertiesInCart = (cartType) => {
  const data = new FormData();
  data.append('action', 'checkAllowedPropertiesInCart');
  data.append('cartType', cartType);

  return fetch('/wp/wp-admin/admin-ajax.php', {
    method: 'POST',
    credentials: 'same-origin',
    body: data,
  });
};

export const disableAddToCartButtons = () => {
  const buttons = document.querySelectorAll('.btn-more-link');

  buttons.forEach((button) => (button.disabled = true));
};

export const enabledAddToCartButtons = () => {
  const buttons = document.querySelectorAll('.btn-more-link');

  buttons.forEach((button) => (button.disabled = false));
};

export const disableRemoveToCartButtons = () => {
  const buttons = document.querySelectorAll('.add-to-cart-button-remove');

  buttons.forEach((button) => (button.disabled = true));
};

export const enabledRemoveToCartButtons = () => {
  const buttons = document.querySelectorAll('.add-to-cart-button-remove');

  buttons.forEach((button) => (button.disabled = false));
};

export const hideLoader = (action, idValue) => {
  const element = document.querySelectorAll(`[data-hideid="${idValue}"]`);

  for (let i = 0; i < element.length; i++) {
    element[i].classList[action]('hide-loader');
  }
};

export const hideLoaders = (action, idsValue) => {
  const selectors = idsValue.map((id) => `[data-hideid="${id}"]`);
  const element = document.querySelectorAll(`${selectors.join(',')}`);

  for (let i = 0; i < element.length; i++) {
    element[i].classList[action]('hide-loader');
  }
};

const handleAlertAction = (alert, action, headline, description) => {
  const alertHeadline = alert.querySelector('.cs-alert__content__headline'),
    alertDescription = alert.querySelector('.cs-alert__content__description');

  if (headline) alertHeadline.innerHTML = headline;
  if (description) alertDescription.innerHTML = description;

  alert.classList[action]('cs-alert--visible');
};

export const toggleCustomAlert = (headline, description) => {
  const alert = document.querySelector('.cs-alert');

  handleAlertAction(alert, 'add', headline, description);

  setTimeout(() => {
    handleAlertAction(alert, 'remove');
  }, 8000);
};

export const setCartItemsCookie = (cartName, itemId) => {
  let itemsToBeRemoved = {};

  if (Cookies.get('cartItemsToBeRemoved')) {
    itemsToBeRemoved = JSON.parse(Cookies.get('cartItemsToBeRemoved'));
  }

  if (!itemsToBeRemoved[cartName]) {
    itemsToBeRemoved[cartName] = [];
  }

  if (itemsToBeRemoved[cartName]?.includes(itemId) === false) {
    itemsToBeRemoved[cartName].push(itemId);
  }

  Cookies.set(`cartItemsToBeRemoved`, JSON.stringify(itemsToBeRemoved), {
    expires: 30,
  });
};

export const removeItemFromCartItemsCookie = (cartName, itemId) => {
  let itemsToBeRemoved = JSON.parse(Cookies.get('cartItemsToBeRemoved'));
  const index = itemsToBeRemoved[cartName].indexOf(itemId);

  if (index > -1) {
    itemsToBeRemoved[cartName].splice(index, 1);
  }

  Cookies.set(`cartItemsToBeRemoved`, JSON.stringify(itemsToBeRemoved), {
    expires: 3,
  });
};

export const updateCartTotalNumber = (cartName) => {
  let asoApartmentsTotal = document.querySelectorAll(
      '[data-wordpress_as_cart_aso_apartment_total]'
    ),
    asoApartmentsRentTotal = document.querySelectorAll(
      '[data-wordpress_as_cart_rent_apartment_total]'
    ),
    cartItemsTotal =
      getCart(cartName).length != 0 ? getCart(cartName).length : '';

  // Sometimes there's apartments in cookies that are no longer in WP. Do not add these to the total count.
  if (REMOVED_APARTMENTS[cartName]) {
    const removedItemsCount = Object.keys(REMOVED_APARTMENTS[cartName]).length;
    cartItemsTotal = cartItemsTotal - removedItemsCount;

    if (cartItemsTotal <= 0) {
      cartItemsTotal = '';
    }
  }

  if (
    asoApartmentsTotal != null &&
    cartName === 'wordpress_as_cart_aso_apartment'
  ) {
    asoApartmentsTotal.forEach((item) => {
      item.innerHTML = cartItemsTotal;
    });
  } else if (
    asoApartmentsTotal != null &&
    cartName === 'wordpress_as_cart_rent_apartment'
  ) {
    asoApartmentsRentTotal.forEach((item) => {
      item.innerHTML = cartItemsTotal;
    });
  }
};

export const currentApartmentTypeTotalApartments = (scope) => {
  const apartmentTypeAttributeName =
    'data-application-remove-from-cart-apartment-type-value';

  let apartments = scope.context.scope.element.parentElement.children;
  let currentApartmentTypeApartments = 0;
  let currentApartmentType = scope.context.scope.element.getAttribute(
    apartmentTypeAttributeName
  );

  if (apartments) {
    for (let i = 0; i < apartments.length; i++) {
      if (
        apartments[i].getAttribute(apartmentTypeAttributeName) ===
        currentApartmentType
      ) {
        currentApartmentTypeApartments++;
      }
    }
  }

  return currentApartmentTypeApartments;
};

export const toggleAllSwitches = (ids, checked) => {
  const selectors = ids.map((id) => `[data-add-to-cart-id-value="${id}"]`);

  const switchesWrappers = document.querySelectorAll(`${selectors.join(',')}`);
  if (!switchesWrappers) {
    return false;
  }

  switchesWrappers.forEach((div) => {
    const checkbox = div.querySelector('input[type="checkbox"]');
    if (!checkbox) {
      return false;
    }
    checkbox.checked = checked;
    if (checkbox.classList.contains('keep-disabled')) {
      checkbox.disabled = true;
    } else {
      checkbox.disabled = checked;
    }
  });
};

export const fadeOut = (element, delay) => {
  let opacity = 1;

  const interval = setInterval(() => {
    if (opacity > 0) {
      opacity -= 0.1;
      element.style.opacity = opacity;
    } else {
      // Stop the interval when opacity reaches 0.
      clearInterval(interval);
      element.classList.add('hidden');
    }
  }, delay);
};

export const showAddedToCartPopupAlert = (alertId) => {
  const alert = document.querySelector(`[data-alert="${alertId}"]`);

  if (!alert) {
    return false;
  }

  // Make sure alert is visible before fading out.
  alert.classList.remove('hidden');
  alert.style.opacity = 1;

  // Hide alert after 5 seconds.
  setTimeout(() => {
    fadeOut(alert, 25);
  }, 5000);
};
